import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL_AGENDA_AND_MEETING;

const httpClient = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 120000
});

httpClient.interceptors.response.use(
  response => response,
  error => errorInterceptor(error)
);

const errorInterceptor = error => {
  if (error && !error.response) {
    if (error.code === "ECONNABORTED") {
      error.response = {
        data: {
          isSucess: false,
          error:
            "Request has timed out. Please try again, if issue persists then call our support team"
        }
      };
    }
  }
  return Promise.reject(error);
};

export default {
  healthCheck() {
    return httpClient.get(baseUrl);
  },
  subscriptionVerification(token) {
    return httpClient.get(`${baseUrl}subscriber/subscribe/${token}`);
  },
  unsubscribeVerification(token) {
    return httpClient.get(`${baseUrl}subscriber/unsubscribe/${token}`);
  },
  createSubscription(payload) {
    return httpClient.post(`${baseUrl}subscriber/create`, payload);
  }
};
